import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, input, output, ChangeDetectionStrategy } from '@angular/core';
import { EmbeddedComponent } from '@maximizer/core/shared/ui/components/base';
import { UI_PIPES } from '@maximizer/core/shared/ui/pipes';
import { CaseService } from '@maximizer/outlook/case/data-access';
import { OutlookStore } from '@maximizer/outlook/shared/data-access';
import { CaseSummary } from '@maximizer/outlook/shared/domain';
import { OUTLOOK_SHARED_UI } from '@maximizer/outlook/shared/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { catchError, finalize, of } from 'rxjs';

@Component({
  selector: 'maximizer-summary-case',
  templateUrl: './summary-case.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DatePipe, OUTLOOK_SHARED_UI, TranslatePipe, UI_PIPES],
})
export class SummaryCaseComponent extends EmbeddedComponent implements OnInit {
  loadErrorEvent = output<string>();
  loadingEvent = output<boolean>();

  deepLink = input<string>();
  id = input('');

  configuration: CaseSummary = { casesAmount: 0 };
  loading = true;

  constructor(
    element: ElementRef,
    private readonly caseService: CaseService,
    public outlookStore: OutlookStore,
  ) {
    super(element);
  }

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    this.caseService
      .getSummary(this.id())
      .pipe(
        catchError(() => {
          this.loadErrorEvent.emit('case');
          return of(null);
        }),
        finalize(() => {
          this.loadingEvent.emit(false);
          this.loading = false;
        }),
      )
      .subscribe((data) => {
        if (!data) return;

        this.configuration = data;
      });
  }
}
